<template>
  <div class="relative flex flex-col w-full items-center bg-black/40 backdrop-blur-sm border-t border-t-white/10 text-white font-semibold tracking-wider text-xs">
    <div class="relative w-full grid grid-cols-12 auto-cols-max py-4 px-6 min-h-[30vh]">
      <div class="col-span-12 sm:col-span-4 md:col-span-3 flex flex-col items-center sm:items-start mb-8">
        <!-- <img class="h-6 cursor-pointer mb-2" width="73" height="24" alt="Oxbull.Tech Logo" @click="redirectToHome()" src="https://oxbull-presale.s3.amazonaws.com/oxb_green_header.png" /> -->
        <img class="h-6 cursor-pointer mb-2" alt="Oxbull.Tech Logo" @click="redirectToHome()" src="https://oxbull.twic.pics/oxbull-logo.webp?twic=v1/cover=-x32" />
      </div>
      <div class="col-span-12 sm:col-span-6 grid grid-cols-12 py-2">
        <div class="col-span-12 sm:col-span-6 flex flex-col items-center mb-8">
          <div class="relative text-center sm:text-left">
            <p class="mb-4">OXBULL</p>
            <div class="sm:absolute left-0 top-[100%] pt-2">
              <a target="_blank" href="https://docs.oxbull.tech" class="border-l border-l-turquoise-500 pl-2 text-white/80 tracking-wide hover:text-white whitespace-nowrap">ABOUT US</a>
            </div>
          </div>
        </div>
        <div class="col-span-12 sm:col-span-6 flex flex-col items-center mb-8">
          <div class="relative text-center sm:text-left">
            <p class="mb-4">TERMS</p>
            <div class="sm:absolute left-0 top-[100%] pt-2 flex flex-col">
              <a target="_blank" href="https://oxbull.medium.com/introducing-oxbull-immunity-f6b9f9fe7453" class="border-l border-l-turquoise-500 pl-2 text-white/80 tracking-wide hover:text-white whitespace-nowrap mb-4">OXBULL IMMUNITY</a>
              <a target="_blank" href="/privacy" class="border-l border-l-turquoise-500 pl-2 text-white/80 tracking-wide hover:text-white whitespace-nowrap">PRIVACY POLICY</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-12 sm:col-span-2 md:col-span-3 mb-12">
        <div class="flex flex-row flex-nowrap w-full justify-center sm:justify-end items-center">

          
          <a target="_blank" href="https://cryptorank.io/fundraising-platforms/oxbull" aria-label="Oxbull.tech Cryptorank">
            <!-- <Icon name="fa:twitter" class="text-4xl md:text-3xl mr-6" /> -->
            <img class="h-[2.25rem] w-[2.25rem] mr-6" src="/symbol_white.png" alt="Cryptorank logo" />
          </a>
          <a target="_blank" href="https://twitter.com/OxBull5" aria-label="Oxbull.tech Twitter link">
            <Icon name="fa:twitter" class="text-4xl md:text-3xl mr-6" />
          </a>
          <a target="_blank" href="https://t.me/Oxbull_tech" aria-label="Oxbull.tech Telegram link">
            <Icon name="fa:paper-plane" class="text-4xl md:text-3xl" />
          </a>
        </div>
      </div>
      <span class="absolute left-0 bottom-0 text-white/80 tracking-wide flex flex-row w-full justify-center pb-2">© 2024 Oxbull.Tech</span>
    </div>
  </div>
</template>

<script setup>
function redirectToHome() {
  window.location.href = "/";
}
</script>
